module.exports = __webpack_public_path__ + "img/saxophone5.380f8700.png";